import { z } from "zod";
import { AccountId } from "./ids.ts";

/** Lifecycle states for an account row. `frozen` blocks all sub-wallet activity. */
export const AccountStatus = z.enum(["active", "frozen", "closed"]);
export type AccountStatus = z.output<typeof AccountStatus>;

/**
 * Root tenant — accounts are the boundary every other table partitions on
 * (composite PK `(account_id, id)`). Email is unique; the password / 2FA
 * material lives in a separate auth table (#5).
 */
export const Account = z.object({
  id: AccountId,
  email: z.string().email().max(254),
  status: AccountStatus,
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export type Account = z.output<typeof Account>;
